import React from 'react'

const SQL_Cloud = () => {
  return (
    <div>
        {/* collapseFiftySix */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingFiftySix">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFiftySix" aria-expanded="false" aria-controls="collapseFiftySix">
                    SQL <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseFiftySix" className="accordion-collapse collapse" aria-labelledby="headingFiftySix" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Introduction to Database</strong>
                    <ul>
                        <li>List the features of Oracle Database 11g</li>
                        <li>Discuss the basic design, theoretical, and physical aspects of a relational database</li>
                        <li>Categorize the different types of SQL statements</li>
                        <li>Describe the data set used by the course</li>
                        <li>Log on to the database using SQL Developer environment</li>
                        <li>Save queries to files and use script files in SQL Developer</li>
                    </ul>

                    <strong>Hands-on-Exercise:</strong>
                    <ul>
                        <li>Prepare your environment</li>
                        <li>Work with Oracle database tools</li>
                        <li>Understand and work with language features</li>
                    </ul>

                    <strong>Retrieve Data using the SQL SELECT Statement</strong>
                    <ul>
                        <li>List the capabilities of SQL SELECT statements</li>
                        <li>Generate a report of data from the output of a basic SELECT statement</li>
                        <li>Select All Columns</li>
                        <li>Select Specific Columns</li>
                        <li>Use Column Heading Defaults</li>
                        <li>Use Arithmetic Operators</li>
                        <li>Understand Operator Precedence</li>
                        <li>Learn the DESCRIBE command to display the table structure</li>
                    </ul>

                    <strong>Hands-on-Exercise:</strong>
                    <ul>
                        <li>Individual statements in SQL scripts are commonly terminated by a line break (or carriage return) and a forward slash on the next line, instead of a semicolon.</li>
                        <li>You can create a SELECT statement, terminate it with a line break, include a forward slash to execute the statement, and save it in a script file</li>
                    </ul>

                    <strong>Learn to Restrict and Sort Data</strong>
                    <ul>
                        <li>Write queries that contain a WHERE clause to limit the output retrieved</li>
                        <li>List the comparison operators and logical operators that are used in a WHERE clause</li>
                        <li>Describe the rules of precedence for comparison and logical operators</li>
                        <li>Use character string literals in the WHERE clause</li>
                        <li>Write queries that contain an ORDER BY clause to sort the output of a SELECT statement</li>
                        <li>Sort output in descending and ascending order</li>
                    </ul>

                    <strong>Hands-on-Exercise:</strong>
                    <ul>
                        <li>Creating the queries in a compound query must return the same number of columns.</li>
                        <li>Create corresponding columns in each query must be of compatible data types.</li>
                        <li>ORDER BY; it is, however, permissible to place a single ORDER BY clause at the end of the compound query</li>
                    </ul>

                    <strong>Usage of Single-Row Functions to Customize Output</strong>
                    <ul>
                        <li>Describe the differences between single row and multiple row functions</li>
                        <li>Manipulate strings with character function in the SELECT and WHERE clauses</li>
                        <li>Manipulate numbers with the ROUND, TRUNC, and MOD functions</li>
                        <li>Perform arithmetic with date data</li>
                        <li>Manipulate dates with the DATE functions</li>
                    </ul>

                    <strong>Hands-on-Exercise:</strong>
                    <ul>
                        <li>Create the distinction is made between single- row functions, which execute once for each</li>
                        <li>row in a dataset, and multiple-row functions, which execute once for all the rows in a data-set.</li>
                    </ul>

                    <strong>Invoke Conversion Functions and Conditional Expressions</strong>
                    <ul>
                        <li>Describe implicit and explicit data type conversion</li>
                        <li>Use the TO_CHAR, TO_NUMBER, and TO_DATE conversion functions</li>
                        <li>Nest multiple functions</li>
                        <li>Apply the NVL, NULLIF, and COALESCE functions to data</li>
                        <li>Use conditional IF THEN ELSE logic in a SELECT</li>
                    </ul>

                    <strong>Hands-on-Exercise:</strong>
                    <ul>
                        <li>we create and discuss the NVL function, which provides a mechanism to convert null values into more arithmetic-friendly data values</li>
                    </ul>

                    <strong>Aggregate Data Using the Group Functions</strong>
                    <ul>
                        <li>Use the aggregation functions in SELECT statements to produce meaningful reports</li>
                        <li>Divide the data into groups by using the GROUP BY clause</li>
                        <li>Exclude groups of data by using the HAVING clause</li>
                    </ul>

                    <strong>Hands-on Exercise</strong>
                    <ul>
                        <li>Group functions operate on aggregated data and return a single result per group.</li>
                        <li>These groups usually consist of zero or more rows of data.</li>
                    </ul>

                    <strong>Display Data from Multiple Tables Using Joins</strong>
                    <ul>
                        <li>Write SELECT statements to access data from more than one table</li>
                        <li>View data that generally does not meet a join condition by using outer joins</li>
                        <li>Join a table by using a self-join</li>
                    </ul>

                    <strong>Use Subqueries to Solve Queries</strong>
                    <ul>
                        <li>Describe the types of problem that subqueries can solve</li>
                        <li>Define sub-queries</li>
                        <li>List the types of sub-queries</li>
                    </ul>

                    <strong>Hands-on Exercise</strong>
                    <ul>
                        <li>Write a query that uses subqueries in the column projection list.</li>
                        <li>Write single-row and multiple-row subqueries</li>
                    </ul>

                    <strong>The SET Operators</strong>
                    <ul>
                        <li>Describe the SET operators</li>
                        <li>Use a SET operator to combine multiple queries into a single query</li>
                        <li>Control the order of rows returned</li>
                    </ul>

                    <strong>Hands-on Exercise</strong>
                    <ul>
                        <li>Create: The queries in the compound query must return the same number of columns.</li>
                        <li>Creating: The corresponding columns must be of compatible data type.</li>
                        <li>Creating: The set operators have equal precedence and will be applied in the order they are specified.</li>
                    </ul>

                    <strong>Data Manipulation Statements</strong>
                    <ul>
                        <li>Describe each DML statement</li>
                        <li>Insert rows into a table</li>
                        <li>Change rows in a table by the UPDATE statement</li>
                        <li>Delete rows from a table with the DELETE statement</li>
                        <li>Save and discard changes with the COMMIT and ROLLBACK statements</li>
                        <li>Explain read consistency</li>
                    </ul>

                    <strong>Hands-on Exercise</strong>
                    <ul>
                        <li>Expressions and create expose a vista of data manipulation possibilities through the interaction of arithmetic and character operators with column or literal data, or a combination of the two.</li>
                    </ul>

                    <strong>Use of DDL Statements to Create and Manage Tables</strong>
                    <ul>
                        <li>Categorize the main database objects</li>
                        <li>Review the table structure</li>
                        <li>List the data types available for columns</li>
                        <li>Create a simple table</li>
                        <li>Decipher how constraints can be created at table creation</li>
                        <li>Describe how schema objects work</li>
                    </ul>

                    <strong>Other Schema Objects</strong>
                    <ul>
                        <li>Create a simple and complex view</li>
                        <li>Retrieve data from views</li>
                        <li>Create, maintain, and use sequences</li>
                        <li>Create and maintain indexes</li>
                        <li>Create private and public synonyms</li>
                    </ul>

                    <strong>Control User Access</strong>
                    <ul>
                        <li>Differentiate system privileges from object privileges</li>
                        <li>Create Users</li>
                        <li>Grant System Privileges</li>
                        <li>Create and Grant Privileges to a Role</li>
                        <li>Change Your Password</li>
                        <li>Grant Object Privileges</li>
                        <li>How to pass on privileges?</li>
                        <li>Revoke Object Privileges</li>
                    </ul>

                    <strong>Hands-on Exercise</strong>
                    <ul>
                        <li>Create users and execute</li>
                    </ul>

                    <strong>Management of Schema Objects</strong>
                    <ul>
                        <li>Add, Modify and Drop a Column</li>
                        <li>Add, Drop and Defer a Constraint</li>
                        <li>How to enable and Disable a Constraint?</li>
                        <li>Create and Remove Indexes</li>
                        <li>Create a Function-Based Index</li>
                        <li>Perform Flashback Operations</li>
                        <li>Create an External Table by Using ORACLE_LOADER and by Using ORACLE_DATAPUMP</li>
                        <li>Query External Tables</li>
                    </ul>

                    <strong>Hands-on Exercise</strong>
                    <ul>
                        <li>Create the function based index and types.</li>
                    </ul>

                    <strong>Manage Objects with Data Dictionary Views</strong>
                    <ul>
                        <li>Explain the data dictionary</li>
                        <li>Use the Dictionary Views</li>
                        <li>USER_OBJECTS and ALL_OBJECTS Views</li>
                        <li>Table and Column Information</li>
                        <li>Query the dictionary views for constraint</li>
                        <li>Query the dictionary views for view, sequence, index, and synonym information</li>
                        <li>Add a comment to a table</li>
                        <li>Query the dictionary views for comment information</li>
                    </ul>

                    <strong>Manipulate Large Data Sets</strong>
                    <ul>
                        <li>Use Subqueries to Manipulate Data</li>
                        <li>Retrieve Data Using a Subquery as Source</li>
                        <li>Insert Using a Subquery as a Target</li>
                        <li>Usage of the WITH CHECK OPTION Keyword on DML Statements</li>
                        <li>List the types of Multitable INSERT Statements</li>
                        <li>Use Multitable INSERT Statements</li>
                        <li>Merge rows in a table</li>
                        <li>Track Changes in Data over a period of time</li>
                    </ul>

                    <strong>Data Management in Different Time Zones</strong>
                    <ul>
                        <li>Time Zones</li>
                        <li>CURRENT_DATE, CURRENT_TIMESTAMP, and LOCALTIMESTAMP</li>
                        <li>Compare Date and Time in a Session's Time Zone</li>
                        <li>DBTIMEZONE and SESSIONTIMEZONE</li>
                        <li>Difference between DATE and TIMESTAMP</li>
                        <li>INTERVAL Data Types</li>
                        <li>Use EXTRACT, TZ_OFFSET, and FROM_TZ</li>
                        <li>Invoke TO_TIMESTAMP, TO_YMINTERVAL and TO_DSINTERVAL</li>
                    </ul>

                    <strong>Retrieve Data Using Sub-queries</strong>
                    <ul>
                        <li>Multiple-Column Subqueries</li>
                        <li>Pairwise and Non Pairwise Comparison</li>
                        <li>Scalar Subquery Expressions</li>
                        <li>Solve problems with Correlated Subqueries</li>
                        <li>Update and Delete Rows Using Correlated Subqueries</li>
                    </ul>

              
                    <strong>Retrieve Data Using Sub-queries</strong>
                    <ul>
                        <li>Use the Regular Expressions Functions and Conditions in SQL</li>
                        <li>Use Meta Characters with Regular Expressions</li>
                        <li>Perform a Basic Search using the REGEXP_LIKE function</li>
                        <li>Find patterns using the REGEXP_INSTR function</li>
                        <li>Extract Substrings using the REGEXP_SUBSTR function</li>
                        <li>Replace Patterns Using the REGEXP_REPLACE function</li>
                        <li>Usage of Sub-Expressions with Regular Expression Support</li>
                        <li>Implement the REGEXP_COUNT function</li>
                    </ul>
                    <strong>Hands-on-exercise:</strong>
                    <ul>
                        <li>Expressions and create the regular columns may be aliased using the AS keyword or by leaving a space between the column or expression and the alias.</li>
                        <li>In this way, both wildcard symbols can be used as either specialized or regular characters in different segments of the same character string.</li>
                    </ul>

                </div>
            </div>
        </div>

    </div>
  )
}

export default SQL_Cloud